export const journeyDestinations = {
  bankReact: 'bank_react',
  bankEmber: 'bank_ember',
  invest: 'invest',
  wealth: 'wealth',
  auto: 'auto',
  mortgage: 'mortgage'
};
